import axios from "axios";

export const url =
  process.env.NODE_ENV === "development"
    ? "https://localhost:443/"
    : "https://api-dev.zaivu.com/";
//:  "http://52.67.10.38:5000/";
const api = axios.create({
  baseURL: url,
});

async function refreshToken(error) {
  return new Promise((resolve, reject) => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      const user = localStorage.getItem("user");

      axios
        .post(url + "auth/new-token", { refreshToken, userId: user._id })
        .then(async (res) => {
          localStorage.setItem("token", res.data.token);
          console.log("updating refresh");

          return resolve(res);
        })
        .catch(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("user");

          window.location.reload();

          return reject(error);
        });
    } catch (err) {
      console.log("error refresh");
      return reject(err);
    }
  });
}

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const token = localStorage.getItem("token");
    const originalReq = error.config;
    if (
      error.response.status === 401 &&
      token &&
      !error.config.__isRetryRequest
    ) {
      originalReq._retry = true;

      await refreshToken(error, originalReq);

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("token");
      originalReq.headers["Authorization"] =
        "Bearer " + localStorage.getItem("token");

      return axios(originalReq);
    }
    return Promise.reject(error);
  }
);

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default api;
